/* Owner-reviewed Demi/Bold composition, with the collection shopping list. */
(() => {
  if (window.productGuidanceReviewInitialized) return;
  window.productGuidanceReviewInitialized = true;
  const arrange = () => {
    const family = document.querySelector('[data-collection-shopping][data-reviewed-layout]');
    if (!family) return;
    const product = family.closest('product-info');
    if (!product) return;
    product.dataset.guidanceReview = '';
    const grid = product.querySelector('.product');
    if (grid && family.parentElement !== grid) grid.append(family);
    const sku = product.querySelector('.product__sku');
    if (sku && !sku.dataset.guidancePriceApplied) {
      const price = sku.querySelector('[data-selected-purchase-price]');
      const currency = price?.previousElementSibling;
      if (price && currency) {
        price.textContent = price.textContent.replace(/^\s*·\s*Selected price:\s*/, '');
        currency.textContent = currency.textContent.replace(/^\s*·\s*Price currency:\s*/, '');
        currency.dataset.purchaseCurrency = '';
        sku.prepend(price, currency);
        sku.dataset.guidancePriceApplied = 'true';
      }
    }
    const support = product.querySelector('[data-product-support-row]');
    const heading = support?.querySelector('h2');
    if (heading) { heading.textContent = 'Product details'; heading.id = 'product-details-review'; }
    const openEssentials = () => support?.querySelectorAll('[data-product-purchase-detail] > details').forEach(details => {
      const title = details.querySelector('summary h3')?.textContent.trim();
      if (!["What's Included?", 'Materials & Finishes'].includes(title) || details.dataset.guidanceDefaultApplied) return;
      details.open = true;
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      details.dataset.guidanceDefaultApplied = 'true';
    });
    openEssentials();
    if (support && !support.dataset.guidanceObserved) {
      support.dataset.guidanceObserved = 'true';
      support.querySelectorAll('.product-support-row__panel').forEach(panel => new MutationObserver(openEssentials).observe(panel, {childList:true}));
    }
    const faq = document.querySelector('[data-product-questions-review]')?.closest('.shopify-section');
    const reviews = document.querySelector('[id$="__1761005796e540868f"]');
    const alternatives = document.querySelector('[data-paired-products]')?.closest('.shopify-section');
    if (faq && reviews && alternatives && faq.parentElement === reviews.parentElement) {
      if (reviews.previousElementSibling !== faq) reviews.before(faq);
      if (reviews.nextElementSibling !== alternatives) reviews.after(alternatives);
    }
    // Curated collection pieces and alternatives already cover these choices.
    const recommendations = document.querySelector('[id$="__related-products"]');
    if (recommendations) recommendations.hidden = true;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrange, {once:true});
  else arrange();
  document.addEventListener('product-info:loaded', arrange);
  document.addEventListener('shopify:section:load', arrange);
  // Shopify replaces SKU contents when a variant changes, keeping the parent.
  document.addEventListener('change', event => {
    if (!event.target.closest('variant-selects')) return;
    const sku = document.querySelector('[data-guidance-review] .product__sku');
    if (!sku) return;
    const observer = new MutationObserver(() => {
      observer.disconnect();
      delete sku.dataset.guidancePriceApplied;
      arrange();
    });
    observer.observe(sku, {childList:true});
    window.setTimeout(() => observer.disconnect(), 15000);
  });
})();
